const locale = {
  placeholder: 'เลือกเวลา',
};

export default locale;
